export const chartDataProspect = [
  {
    m: 500,
    d: '2022-05-01',
  },
  {
    m: 500,
    d: '2022-05-02',
  },
  {
    m: 500,
    d: '2022-05-03',
  },
  {
    m: 500,
    d: '2022-05-04',
  },
  {
    m: 500,
    d: '2022-05-05',
  },
  {
    m: 500,
    d: '2022-05-06',
  },
  {
    m: 500,
    d: '2022-05-07',
  },
  {
    m: 500,
    d: '2022-05-08',
  },
  {
    m: 500,
    d: '2022-05-09',
  },
  {
    m: 500,
    d: '2022-05-10',
  },
  {
    m: 500,
    d: '2022-05-11',
  },
  {
    m: 500,
    d: '2022-05-12',
  },
  {
    m: 500,
    d: '2022-05-13',
  },
  {
    m: 500,
    d: '2022-05-14',
  },
  {
    m: 500,
    d: '2022-05-15',
  },
  {
    m: 500,
    d: '2022-05-16',
  },
  {
    m: 40,
    d: '2022-05-17',
  },
  {
    m: 500,
    d: '2022-05-18',
  },
  {
    m: 500,
    d: '2022-05-19',
  },
  {
    m: 500,
    d: '2022-05-20',
  },
  {
    m: 500,
    d: '2022-05-21',
  },
  {
    m: 500,
    d: '2022-05-22',
  },
  {
    m: 500,
    d: '2022-05-23',
  },
  {
    m: 100,
    d: '2022-05-24',
  },
  {
    m: 500,
    d: '2022-05-25',
  },
  {
    m: 500,
    d: '2022-05-26',
  },
  {
    m: 770,
    d: '2022-05-27',
  },
  {
    m: 200,
    d: '2022-05-28',
  },
  {
    m: 700,
    d: '2022-05-29',
  },
  {
    m: 500,
    d: '2022-05-30',
  },
  {
    m: 1500,
    d: '2022-05-31',
  },
];
